import { Components, Theme } from '@mui/material';

export const MuiPopover: Components<Theme>['MuiPopover'] = {
  styleOverrides: {
    paper: {
      boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
      borderRadius: 4,
      marginTop: 8,
    },
  },
};
